import { string } from 'prop-types';
import { api } from './api';

export async function getNecs(payload?: string) {
  try {
    const { data } = await api.post(
      'database/nec__c/aggregate',
      payload
        ? [
            {
              $match: {
                $or: [
                  {
                    cd_alcc: {
                      $regex: payload,
                      $options: 'i',
                    },
                  },
                  {
                    nm_alcc: {
                      $regex: payload,
                      $options: 'i',
                    },
                  },
                  {
                    nm_uor_sltt: {
                      $regex: payload,
                      $options: 'i',
                    },
                  },
                ],
              },
            },
          ]
        : [],
    );

    return data;
  } catch (e) {
    return [];
  }
}

export async function getDemandantes() {
  try {
    const { data } = await api.post('database/nec__c/aggregate', [
      {
        $group: {
          _id: '$nm_uor_sltt',
        },
      },
      {
        $project: {
          _id: 0,
          nm_uor_sltt: '$_id',
        },
      },
    ]);

    return data;
  } catch (e) {
    return [];
  }
}
export async function getUors(cod_urs?: number) {
  try {
    const payload = [
      {
        $match: {
          cd_uor: cod_urs?.toString(),
        },
      },
    ];
    const { data } = await api.post('database/uors__c/aggregate', payload);

    return data;
  } catch (e) {
    return [];
  }
}
